<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Kolekcja Stare Dęby</h3>
    </app-contentpageheader>
    <app-old-oak />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../../components/common/ContentPageHeader.vue";

import OldOak from "../../components/collections/types/OldOak.vue";
import Footer from "../../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../../assets/common/wood.jpg")
    };
  },
  components: {
    "app-old-oak": OldOak,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
